import * as styles from './styles';
import { MissingPage as MissingPageSvg } from '~components';

function GenericError() {
  const handleClick = () => {
    window.location.assign('/');
  };

  return (
    <div style={styles.wrapperStyles}>
      <MissingPageSvg />
      <h1 style={styles.titleStyles}>Algo deu errado</h1>
      <p style={styles.descriptionStyles}>
        Estamos trabalhando para resolver esse problema. Volte novamente mais
        tarde.
      </p>
      <button onClick={handleClick} style={styles.buttonStyles}>
        Voltar ao início
      </button>
    </div>
  );
}

export default GenericError;
